import React from 'react';
import {
  WhiteInstantSearchBuilder,
  Loading,
  mappers,
  MenuPanel,
  Pagination,
  SearchBox,
} from '@white-nl/instantsearch-components';

import { MagnifyingGlassSharpRegular, XmarkSharpRegular } from '../components/ui/icons';
import { Hit as FaqHit } from '../components/faq/results/Hit';
import NoResults from '../components/faq/NoResults';

const settings = document.getElementById('faq-filters')?.dataset || null;
const whiteInstantSearchFaq = new WhiteInstantSearchBuilder();
if (settings) {
  const graphqlUrl = `${settings.nodeUrl}api/categories/faq`;
  fetch(graphqlUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ siteId: settings.siteId }),
  }).then((res) => res.json())
    .then((categories) => {
      const categoryLabelMapping: any = {};
      categories.faqCategoryEntries.forEach(
        (category: {
          __typename: string;
          uri: string;
          title: string;
        }) => {
          categoryLabelMapping[category.uri] = category.title;
        },
      );
      categoryLabelMapping.faq = categories.faqGeneralEntries[0].title;
      whiteInstantSearchFaq
        .withSearchkit(
          settings.indexName || '',
          settings.publicUrl || '',
          settings.jwt || '',
          settings.refreshUrl || '',
        )
        .withWhiteInstantSearchRouting({
          baseUrl: settings.baseUrl,
          addToPath: true,
          addTrailingSlashesToUrls: settings.trailingSlashes === '1',
          pathAttribute: 'category.slug',
          writeDelay: 0,
        })
        .addMenu([
          {
            settings: {
              attribute: 'category.slug',
              classNames: {
                root: 'filters-list',
                count: 'filters-count',
                selectedItem: 'active',
              },
              hardRefresh: true,
              sortBy: ['name:asc'],
              transformItems: mappers.transformers.mapLabels(categoryLabelMapping),
              panelSettings: {
                collapsiblePanelSettings: {
                  classNames: {
                    root: 'form-wrap',
                    header: 'filter-title h4',
                  },
                  defaultExpanded: true,
                  canCollapse: false,
                },
                header: Craft.t('faq', 'Category'),
              },
            },
            component: MenuPanel,
          },
        ])
        .addSearchingComponent([
          {
            settings: {
              classNames: {
                submit: 'submit',
                reset: 'submit',
                loadingIndicator: 'submit',
                input: 'form-control',
              },
              submitIconComponent: () => (
                <MagnifyingGlassSharpRegular />
              ),
              resetIconComponent: () => (
                <XmarkSharpRegular />
              ),
              placeholder: Craft.t('faq', 'What is your question?'),
              translations: {
                submitButtonTitle: Craft.t('faq', 'Submit the search query'),
                resetButtonTitle: Craft.t('faq', 'Clear the search query'),
              },
            },
            component: SearchBox,
          },
        ])
        .addHitComponent([
          {
            settings: {
              loading: {
                translations: {
                  loading: Craft.t('faq', 'Loading FAQ...'),
                },
              },
              noResults: {
                translations: {
                  noResults: Craft.t('faq', 'Please filter for your questions in Category.'),
                  refinements: Craft.t('faq', 'Sorry, we can\'t find any FAQ!'),
                  query: Craft.t('faq', 'Sorry, we can\'t find any FAQ related to "{query}".'),
                },
              },
            },
            component: FaqHit,
            loadingComponent: Loading,
            noResultsComponent: NoResults,
          },
        ])
        .addPaginationComponent([
          {
            settings: {
              showFirst: false,
              showLast: false,
              classNames: {
                list: 'pagination',
                item: 'page-item',
                previousPageItem: 'previous',
                selectedItem: 'active',
                disabledItem: 'disabled',
                nextPageItem: 'next',
                link: 'page-link',
              },
              translations: {
                previousPageItemText: Craft.t('pagination', 'Previous'),
                previousPageItemAriaLabel: Craft.t('pagination', 'Go to previous page'),
                nextPageItemText: Craft.t('pagination', 'Next'),
                nextPageItemAriaLabel: Craft.t('pagination', 'Go to next page'),
              },
            },
            component: Pagination,
          },
        ])
        .where(`siteId:${settings.siteId}`)
        .build()
        .show();
    });
}
